// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Switcher-Slider.module.scss  */
.Switcher-Slider-module-Slider_2x1 {
  position: relative;
  display: block;
  width: 44px;
  height: 24px;
  cursor: pointer;
  border-radius: 30px;
  background-color: var(--switcher-background-color);
  transition: background-color 0.3s cubic-bezier(0.39, 0.575, 0.565, 1); }
  .Switcher-Slider-module-Slider_2x1::after {
    position: absolute;
    width: 20px;
    height: 20px;
    content: '';
    border-radius: 20px;
    background-color: #fff;
    transition: width 0.2s, transform 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
    transform: translate3d(2px, 2px, 0); }
  .Switcher-Slider-module-Slider_2x1[aria-checked='true'] {
    background-color: var(--switcher-background-color-active); }
    .Switcher-Slider-module-Slider_2x1[aria-checked='true']::after {
      transform: translate3d(22px, 2px, 0); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Switcher/Slider/Switcher-Slider.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kDAAkD;EAClD,qEAAqE,EAAE;EACvE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,0EAA0E;IAC1E,mCAAmC,EAAE;EACvC;IACE,yDAAyD,EAAE;IAC3D;MACE,oCAAoC,EAAE","sourcesContent":["/*  imported from Switcher-Slider.module.scss  */\n.Switcher-Slider-module-Slider_2x1 {\n  position: relative;\n  display: block;\n  width: 44px;\n  height: 24px;\n  cursor: pointer;\n  border-radius: 30px;\n  background-color: var(--switcher-background-color);\n  transition: background-color 0.3s cubic-bezier(0.39, 0.575, 0.565, 1); }\n  .Switcher-Slider-module-Slider_2x1::after {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    content: '';\n    border-radius: 20px;\n    background-color: #fff;\n    transition: width 0.2s, transform 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);\n    transform: translate3d(2px, 2px, 0); }\n  .Switcher-Slider-module-Slider_2x1[aria-checked='true'] {\n    background-color: var(--switcher-background-color-active); }\n    .Switcher-Slider-module-Slider_2x1[aria-checked='true']::after {\n      transform: translate3d(22px, 2px, 0); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
